import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { gameStore, GameState } from '../game/store';
export function ZoneBanner() {
  const [state, setState] = useState<GameState>(gameStore.getState());
  useEffect(() => gameStore.subscribe(setState), []);
  return <div className="absolute top-1/3 left-0 right-0 flex justify-center pointer-events-none z-30" data-id="element-185">
      <AnimatePresence data-id="element-186">
        {state.zoneBanner && <motion.div key={state.zoneBanner.key} initial={{
        opacity: 0,
        scale: 0.9,
        filter: 'blur(10px)'
      }} animate={{
        opacity: 1,
        scale: 1,
        filter: 'blur(0px)'
      }} exit={{
        opacity: 0,
        y: -20,
        filter: 'blur(8px)'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center" data-id="element-187">
            <motion.div initial={{
          width: 0
        }} animate={{
          width: 240
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="h-px bg-red-500/50 mx-auto mb-4" data-id="element-188" />

            <div className="text-gray-500 text-xs uppercase tracking-[0.5em] mb-2" data-id="element-189">
              NOW ENTERING
            </div>

            <div className="text-4xl md:text-6xl font-black text-white uppercase tracking-wide" style={{
          textShadow: '0 0 30px rgba(255,255,255,0.3), 0 0 60px rgba(220,38,38,0.4)'
        }} data-id="element-190">
              {state.zoneBanner.title}
            </div>

            <div className="text-red-400/80 text-sm md:text-base italic mt-2 tracking-wider" data-id="element-191">
              {state.zoneBanner.subtitle}
            </div>

            <motion.div initial={{
          width: 0
        }} animate={{
          width: 240
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="h-px bg-red-500/50 mx-auto mt-4" data-id="element-192" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}